import { ArrowUpTrayIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { ArrowTopRightOnSquareIcon, DocumentArrowUpIcon } from "@/icons/solid";
import { toTitleCase } from "@/components/common/validation/Validators";
import { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { connect } from "react-redux";
import { Actions as ALLOWANCE_ACTIONS } from "../../../store/actions/allowanceActions";
import { Actions as PAYROLL_ACTIONS } from "../../../store/actions/payrollActions";
import DownloadAllowanceTemplate from "./DownloadAllowanceTemplate";

const HolidayPayModal = ({
	allowanceUploadErrors,
	allowanceUploadProgress,
	modalStatus,
	closeModal,
	payPeriodDetails,
	uploadPayrollAllowances,
	jurisdiction,
	clearErrors,
}) => {
	const [file, setFile] = useState(false);
	const [appendIfExists, setAppendIfExists] = useState(false);
	const [nothingImported, setNothingImported] = useState(false);
	const [ignore, setIgnore] = useState(false);

	const allowanceTitle = jurisdiction == "UK" ? "pay items" : "allowances";

	const selectAllowanceUploadFile = (file) => {
		setFile(file);
	};

	useEffect(() => {
		console.log("clear file after upload");
		if (file && !allowanceUploadProgress) {
			setFile(null);
		}
	}, [allowanceUploadProgress]);

	const processUploadPayrollAllowances = () => {
		let startDate = payPeriodDetails.periodStart;
		let endDate = payPeriodDetails.periodEnd;

		const periodStartDate = startDate;
		const periodEndDate = endDate;

		if (payPeriodDetails && payPeriodDetails.casualStartDate) {
			startDate = payPeriodDetails.casualStartDate;
			endDate = payPeriodDetails.casualEndDate;
		}

		let payDate = payPeriodDetails.payDay;

		const options = {
			file,
			companyPayPeriod: payPeriodDetails.id,
			periodStartDate,
			periodEndDate,
			casualStartDate: startDate,
			casualEndDate: endDate,
			payDate,
			appendIfExists,
		};

		uploadPayrollAllowances(options);
	};

	useEffect(() => {
		const nothing = allowanceUploadErrors?.find(
			(item) => item.data.ID === "MISSING" || item.data.Employee === "MISSING",
		);
		if (nothing) {
			setNothingImported(!!nothing);
		}
	}, [allowanceUploadErrors]);

	useEffect(() => {
		if (!modalStatus) {
			setFile(null);
			setAppendIfExists(false);
			setNothingImported(false);
			if (allowanceUploadErrors) clearErrors();
		}
	}, [modalStatus]);

	if (!modalStatus) return null;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto", height: "100vh" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "40%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Upload {toTitleCase(allowanceTitle)}</h3>
						</div>
						<div className="block-content">
							<p>
								Instead of adding {allowanceTitle} one by one during Payroll you may upload{" "}
								{allowanceTitle} for all your employees at one go. This can be done by filling in our
								template and uploading it.&nbsp;
								<a to="https://support.buddy.hr/hc/en-mt/articles/360021391419-Bulk-Upload-Allowances-using-a-Csv-Sheet">
									Learn More <ArrowTopRightOnSquareIcon className="h-5 w-5" />
								</a>
							</p>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									justifyContent: "space-between",
									alignItems: "center",
									marginBottom: "3rem",
								}}
							>
								<div style={{ width: "50%" }}>
									<FileUploader
										handleChange={selectAllowanceUploadFile}
										name="file"
										children={
											<div className="upload-company-logo">
												<DocumentArrowUpIcon style={{ height: "3.5rem" }} />
												<span>
													{file?.name
														? file?.name
														: `Upload or Drop ${
																jurisdiction == "UK" ? "Pay Items" : "Allowances"
														  } CSV File`}
												</span>
											</div>
										}
										types={["CSV"]}
									/>
								</div>
								{file && (
									<>
										<label
											style={{ marginLeft: "10px" }}
											forHTML="appendIfExists"
											className="css-input switch switch-sm switch-success inline"
											onClick={(e) => {
												e.stopPropagation();
												e.preventDefault();
												setAppendIfExists(!appendIfExists);
											}}
										>
											<input
												id="appendIfExists"
												name="mode"
												type="checkbox"
												checked={appendIfExists}
											/>
											<span />
											Allow repeat {allowanceTitle}
										</label>
										<div className="clearfix" />
										<div
											className="btn btn-success"
											style={{ marginLeft: "10px" }}
											onClick={processUploadPayrollAllowances}
										>
											<ArrowUpTrayIcon
												className="h-7 w-7"
												style={{
													display: "inline",
													verticalAlign: "text-top",
												}}
											/>
											&nbsp; Upload {file.name}
										</div>
									</>
								)}
								{!file && (
									<div style={{ marginTop: "3rem" }}>
										<span>Or download the template if you don't have one</span>
                                        <DownloadAllowanceTemplate />
									</div>
								)}
							</div>

							{(allowanceUploadErrors?.length > 0 || nothingImported) && (
								<div
									className="alert alert-warning"
									style={{ marginTop: "15px" }}
								>
									<h3>Errors were encountered when processing the import</h3>
									{!nothingImported && (
										<p>Entries not listed below have been successfully imported.</p>
									)}
									<ul>
										{allowanceUploadErrors?.map((item) => {
											return (
												<li key={item.data.Employee || item.data.ID}>
													{item.data.Employee || item.data.ID} - {item.error}
												</li>
											);
										})}
									</ul>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		payPeriodDetails: state.payroll?.payPeriodDetails,
		allowanceUploadErrors: state.allowances.allowanceUploadErrors,
		allowanceUploadProgress: state.allowances.allowanceUploadProgress,
		modalStatus: !!state.payroll?.uploadAllowanceModal,
		currency: state.company?.settings?.currency,
		jurisdiction: state.company?.settings?.jurisdiction,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(PAYROLL_ACTIONS.uploadAllowanceModal()),
	uploadPayrollAllowances: (options) => dispatch(ALLOWANCE_ACTIONS.uploadPayrollAllowances(options)),
	clearErrors: (options) => dispatch(ALLOWANCE_ACTIONS.allowancesUploaded({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(HolidayPayModal);
